import Header from "../../../shared/components/Header";
import MenuLateral from "../components/MenuLateral";
import styles from "./HomePrincipal.module.css";
import { Link } from 'react-router-dom';
import FooterOpcoes from "../components/FooterOpcoes";
import { useEffect, useState } from 'react';
import logooficial from '../../../images/logo_speed_order_oficial__img.png';
import { BsArrowRightSquare } from "react-icons/bs";

function HomePrincipal() {
  const nomeEstabelecimento = localStorage.getItem("nomeEstabelecimento");
  const [nome, setNome] = useState('');

  const [pedidos, setPedidos] = useState([
    { id: 1, mesa: "01", item: "X-Bacon", status: "Em Preparo" },
    { id: 2, mesa: "02", item: "X-Salada", status: "Pronto" },
    { id: 3, mesa: "03", item: "X-Egg", status: "Em Preparo" },
  ]);

  useEffect(() => {
    const nomeUsuario = localStorage.getItem("nome_usuario");
    if (nomeUsuario) setNome(nomeUsuario);
  }, []);

  const resumoPedidos = {
    pendentes: pedidos.filter(p => p.status === "Em Preparo").length,
    prontos: pedidos.filter(p => p.status === "Pronto").length,
    cancelados: 0
  };

  return (
    <div className={styles.mainpage}>
      <header className={styles.headerPrincipal}>
        <img src={logooficial} alt="Logo SpeedOrder" className={styles.logo} />
        <div>
          <p className={styles.nomeusuario}>Olá {nome}!</p>
          <p className={styles.nomeEstabelecimento}>Você está no <br/>{nomeEstabelecimento}</p>
        </div>
      </header>

      <main className={styles.mainContent}>
        {/* Blocos de Ação Rápida */}
        <section className={styles.sectionBlocos}>
          <ul className={styles.listaOpcoes}>
            <li className={styles.blocoDecorado}>
              <Link to="/ultimos-pedidos" className={styles.link}>
                Últimos Pedidos
              </Link>
            </li>
            <li className={styles.blocoDecorado}>
              <Link to="/pedidos-prontos" className={styles.link}>
                Pedidos Prontos
              </Link>
            </li>
            <li className={styles.blocoDecorado}>
              <Link to="/pedidos-em-preparo" className={styles.link}>
                Pedidos em Preparo
              </Link>
            </li>
            <li className={styles.blocoDecorado}>
              <Link to="/historico-pedidos" className={styles.link}>
                Histórico
              </Link>
            </li>
          </ul>
        </section>

        {/* Cards de Resumo de Pedidos */}
        <section className={styles.sectionResumo}>
          <h2>Visão Geral dos Pedidos</h2>
          <div className={styles.cardsResumo}>
            <div className={styles.cardResumo}>
              <p className={styles.cardTitle}>Pendentes</p>
              <p className={styles.cardNumber}>{resumoPedidos.pendentes}</p>
            </div>
            <div className={styles.cardResumo}>
              <p className={styles.cardTitle}>Prontos</p>
              <p className={styles.cardNumber}>{resumoPedidos.prontos}</p>
            </div>
            <div className={styles.cardResumo}>
              <p className={styles.cardTitle}>Cancelados</p>
              <p className={styles.cardNumber}>{resumoPedidos.cancelados}</p>
            </div>
          </div>
        </section>

        {/* Últimos Pedidos */}
        <section className={styles.sectionPedidos}>
          <h2>Últimos Pedidos</h2>
          <div className={styles.cardUltimosPedidos}>
            {pedidos.map(p => (
              <div key={p.id} className={styles.pedidoCard}>
                <p><strong>Pedido #{p.id}</strong></p>
                <p>Mesa {p.mesa}</p>
                <p>{p.item}</p>
                <span className={`${styles.statusBadge} ${styles[p.status.replace(' ', '')]}`}>
                  {p.status}
                </span>
              </div>
            ))}
          </div>
        </section>

        <FooterOpcoes />
      </main>
    </div>
  );
}

export default HomePrincipal;
